import { useAuth0 } from '@auth0/auth0-react';
import { useQuery } from '@tanstack/react-query';
import { fetchTransferAuthz } from './api';

/**
 * Resolves the local transfer-portal user (role + org) for the
 * currently authenticated Auth0 identity. Returns `null` if the user
 * is authenticated with Auth0 but not provisioned for this app.
 */
export function useTransferUser() {
  const { isAuthenticated, getAccessTokenSilently, isLoading: auth0Loading } = useAuth0();

  const query = useQuery({
    queryKey: ['transfer-authz'],
    enabled: isAuthenticated,
    queryFn: async () => {
      const token = await getAccessTokenSilently();
      return fetchTransferAuthz(token);
    },
    retry: false,
  });

  return {
    user: query.data ?? null,
    isLoading: auth0Loading || query.isLoading,
    error: query.error,
  };
}
